import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { getResponseMessage } from '../../../../utils/utils';
import { createManufacture, ManufactureParams } from '../../../../crud/manufacturer.crud';

export const useAddManufacture = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const addManufacture = async (params: ManufactureParams) => {
    setLoading(true);
    createManufacture(params)
      .then(() => {
        setSuccess(true);
        enqueueSnackbar(`Производитель успешно добавлен`, {
          variant: 'success',
        });
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
        setTimeout(() => {
          setSuccess(false);
        }, 100);
      });
  };
  return { addManufacture, loading, success };
};
